import React from "react";
import PropTypes from "prop-types";
import Dialog from "./Dialog";

/**
 * Alert dialog
 * @module
 * @param {bool} isOpen - Is dialog open?
 * @param {func} onClose - Function invoked on dialog close
 * @param {string} text - Text of dialog
 * @param {string} [title] - Title
 * @param {string} [confirmText] - Confirm button text
 * @param {string} [cancelText] - Cancel button text
 * @param {number} relativeLeft - Window relative left
 * @param {number} relativeTop - Window relative top  
 */
const AlertDialog = (props) => {
  return (
    <div className="alert-dialog">
      <Dialog
        title={props.title ? props.title : "Upozornenie"}
        onEsc={props.onClose}
        onClose={props.onClose}
        onConfirm={props.onClose}
        isOpen={props.isOpen}
        confirmText={props.confirmText}
        hideCancelBtn={true}
        className={props.className}
        relativeTop={props.relativeTop || 0}
        relativeLeft={props.relativeLeft || 0}
        level={props.level}
      >
        <p style={{ margin: "15px", textAlign: "center" }}>
          {props.text.split(/\n|\\n/).map((x, index) => (<React.Fragment key={index}>{x}<br /></React.Fragment>))}
        </p>
      </Dialog>
    </div>
  );
}

AlertDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  className: PropTypes.string,
  relativeTop: PropTypes.number,
  relativeLeft: PropTypes.number,
  level: PropTypes.number,
}

export default AlertDialog;